module.exports = __webpack_public_path__ + "static/img/87d8194bc9834e9f8f0228e9e530beb1.cfc91f73.jpeg";